import * as types from '../actions/types';

const initialState = {
  // null — перечень ещё не запрашивали; пустой массив — файлов нет
  files: null,
  info: {},
  error: null,
  practice: [],
};

export default function portfolio(state = initialState, action) {
  switch (action.type) {
    case types.PORTFOLIO_LOAD_FILES_LIST:
      return {
        ...state,
        files: action.files,
      };
    case types.PORTFOLIO_DOCUMENT_UPLOAD_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case types.PORTFOLIO_DOCUMENT_LIST_FETCH_COMPLETED:
      return {
        ...state,
        info: action.info,
      };

    case types.SIGNED_OUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
